import { render } from "./NotificationSavePage.vue?vue&type=template&id=64ffb014"
import script from "./NotificationSavePage.vue?vue&type=script&lang=js"
export * from "./NotificationSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script